module.exports = __webpack_public_path__ + "static/img/bg-tr.f8b79bae.png";